import React, { useMemo } from "react";
import { Box } from "@material-ui/core";
import MultiSelectChipsDropdown from "./MultiSelectChipsDropdown.js";

const MultiOutletsDropdown = ({
  resources,
  outlets = [],
  outletIds = [],
  onOutletsChange,
  containerClass,
  labelText = null,
  id = "multi-outlets-dropdown",
  filterFunction = null,
  showSelectAll = false,
  helperText = null,
  error = false
}) => {
  const options = useMemo(() => {
    return [...outlets]
      .filter(filterFunction ?? (() => true))
      .sort((a, b) => (a.description > b.description) ? 1 : -1)
      .map(x => ({ key: x.id, name: x.description }));
  }, [outlets, filterFunction]);

  return (
    <Box className={containerClass} padding="0">
      <MultiSelectChipsDropdown
        id={id}
        label={labelText ?? resources["Outlets"]}
        options={options}
        value={outletIds}
        onChange={onOutletsChange}
        selectAllLabel={showSelectAll ? resources["SelectAll"] : null}
        deselectAllLabel={showSelectAll ? resources["DeselectAll"] : null}
        helperText={helperText}
        error={error}
      />
    </Box>
  );
};

export default MultiOutletsDropdown;
